module.exports = __webpack_public_path__ + "img/icon-st.f85310d5.png";